import { render, staticRenderFns } from "./StaffGridEditor.vue?vue&type=template&id=05cb373a&scoped=true&"
import script from "./StaffGridEditor.vue?vue&type=script&lang=js&"
export * from "./StaffGridEditor.vue?vue&type=script&lang=js&"
import style0 from "./StaffGridEditor.vue?vue&type=style&index=0&id=05cb373a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb373a",
  null
  
)

export default component.exports